module.exports = __webpack_public_path__ + "media/images/icons/outlined/audit-0fb1564e7ac1526134a440c0e93800d8.svg";